export const COTAS_PARLAMENTARES = 'COTAS_PARLAMENTARES';
export const COTAS_PARLAMENTARES_START = 'COTAS_PARLAMENTARES_START';
export const COTAS_PARLAMENTARES_SUCCESS = 'COTAS_PARLAMENTARES_SUCCESS';
export const COTAS_PARLAMENTARES_ERROR = 'COTAS_PARLAMENTARES_ERROR';
